<div class="search-box" *transloco="let t; read:'knowledgeBank.search.box'">
    <search-box (triggerSearch)="search($event)" [ngModel]="query$ | async" (queryChange)="queryChange($event)" [focus]="isMain"
                [autocompleteList]="autocompleteList$ | async" [placeholder]="t('placeholer')">
    </search-box>
</div>
